const CLASS_ACTIVE = 'active';
const {
	mediaQueryMin,
	trackGtm,
	trackGtm4,
	fillWithDomElementsAll,
	fillWithDomElements,
} = require('util/functions');
const {
	default: { breakMedium },
} = require('util/sass-variables');
const {
	DELAY_DEBOUNCE,
	DIRECTION_HORIZONTAL,
	DIRECTION_LEFT,
	DIRECTION_RIGHT,
} = require('util/consts');
const asyncImport = require('util/asyncImport').default;

const CLASS_TABS = 'tab-widget--tab';
const CLASS_DOTS = 'tab-widget--nav-dot';
const CLASS_CONTENTS = 'tab-widget--content';
const CLASS_CTA = 'arrow-link';
const PREV = 'tab-widget--prev-btn';
const NEXT = 'tab-widget--next-btn';

const CLASS_CONTENT_WRAPPER = 'tab-widget--content-wrapper';

const selectorsAll = {
	cta: CLASS_CTA,
	tabs: CLASS_TABS,
	dots: CLASS_DOTS,
	contents: CLASS_CONTENTS,
	btnPrev: PREV,
	btnNext: NEXT,
};
const selector = {
	contentWrapper: CLASS_CONTENT_WRAPPER,
};

module.exports = {
	async init() {
		fillWithDomElements(this, selector);
		fillWithDomElementsAll(this, selectorsAll);

		await asyncImport(this, ['Hammer', 'debounce']);
		this.initEvents();
		this.giveWidthToTabs();
		this.setActiveElement(0);
	},
	initEvents() {
		window.addEventListener('load', this.swiping.bind(this));
		window.addEventListener(
			'resize',
			this.debounce(this.giveWidthToTabs.bind(this), DELAY_DEBOUNCE),
		);
		this.tabs.forEach(tab => {
			tab.addEventListener('click', this.tabClick.bind(this));
		});
		this.dots.forEach(dot => {
			dot.addEventListener('click', this.tabClick.bind(this));
		});
		this.cta.forEach(cta => {
			cta.addEventListener('click', this.gtmTrackingCta.bind(this));
		});
		this.btnNext.forEach(btn => {
			btn.addEventListener('click', this.nextClick.bind(this));
		});
		this.btnPrev.forEach(btn => {
			btn.addEventListener('click', this.prevClick.bind(this));
		});
	},
	giveWidthToTabs() {
		if (!mediaQueryMin(breakMedium)) {
			this.tabs.forEach(tab => {
				tab.style.width = 'auto';
			});
		} else {
			if (this.tabs.length === 3) {
				this.tabs.forEach(tab => {
					tab.style.width = '33%';
				});
			} else if (this.tabs.length === 4) {
				this.tabs.forEach(tab => {
					tab.style.width = '40%';
				});
			}
		}
	},
	tabClick(e) {
		const currentTabIndex = e.currentTarget.dataset.id;
		this.setActiveElement(Number(currentTabIndex), true);
		this.gtmTrackingTab(e);
	},
	nextClick(e) {
		const tabList = [...this.tabs];
		const nextTabId =
			tabList.length - 1 === tabList.findIndex(tab => tab.disabled)
				? 0
				: tabList.findIndex(tab => tab.disabled) + 1;
		this.setActiveElement(Number(nextTabId), true);
		this.gtmTrackingTab(e);
	},
	prevClick(e) {
		const tabList = [...this.tabs];
		const prevTabId =
			tabList.findIndex(tab => tab.disabled) === 0
				? tabList.length - 1
				: tabList.findIndex(tab => tab.disabled) - 1;
		this.setActiveElement(Number(prevTabId), true);
		this.gtmTrackingTab(e);
	},
	gtmTrackingTab(e) {
		const title = this.root.querySelector('.title')
			? this.root.querySelector('.title').innerHTML.trim()
			: 'Title not set';
		const linkText = e.target.textContent
			? e.target.textContent.trim()
			: e.target.classList.contains('tab-widget--next-btn')
			? 'next'
			: 'previous';
		const interactionType = e.target.textContent
			? e.srcElement.classList.contains('tab-widget--nav-dot')
				? `bullet ${e.target.textContent.trim()}`
				: `tab ${e.target.textContent.trim()}`
			: 'slider navigation';
		trackGtm({
			eventCategory: 'cta',
			eventAction: 'tab widget',
			eventLabel: `${e.target.textContent}`,
		});

		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: 'V3-Tab',
			widget_title: title,
			widget_type: 'article',
			link_text: linkText,
			link_url: 'No url',
			interaction_type: interactionType,
		});
	},
	gtmTrackingCta(e) {
		let currentTab;
		const { href, textContent } = e.target;
		this.tabs.forEach(tab => {
			if (tab.disabled) currentTab = tab.textContent;
		});

		trackGtm({
			eventCategory: 'cta',
			eventAction: 'tab widget cta',
			eventLabel: `${currentTab} | ${textContent} | ${href}`,
		});
	},
	tabFocus(index) {
		this.tabs[index].scrollIntoView({
			behaviour: 'smooth',
			block: 'nearest',
			inline: 'center',
		});
	},
	setActiveElement(index, tabClick) {
		this.contentWrapper.style.setProperty('--current-slide', index);
		this.setFocuses(index);
		this.tabs.forEach((tab, tabIndex) => {
			tab.disabled = tabIndex === index;
		});
		this.dots.forEach((dot, dotIndex) => {
			dot.disabled = dotIndex === index;
		});
	},
	setFocuses(index) {
		this.cta.forEach((cta, i) =>
			cta.setAttribute('tabindex', i === index ? 0 : -1),
		);
	},
	getCurrentActiveElement(tabs) {
		return [...tabs].filter(tab => tab.disabled)[0];
	},
	swiping() {
		this.hammerTime = this.Hammer(this.contentWrapper);
		this.hammerTime.get('swipe').set({
			direction: DIRECTION_HORIZONTAL,
		});
		this.hammerTime.on('swipe', e => {
			// Did not put any check for screen sizes, because it is
			// requested to be 'swipable' on desktop as well
			this.activeTab = this.getCurrentActiveElement(this.tabs);
			this.activeTabId = parseInt(this.activeTab.dataset.id);
			this.nextTab = this.activeTabId + 1;
			this.previousTab = this.activeTabId - 1;
			switch (e.direction) {
				case DIRECTION_LEFT:
					this.contents.length !== this.nextTab
						? this.setActiveElement(this.nextTab)
						: this.setActiveElement(0);
					break;
				case DIRECTION_RIGHT:
					this.previousTab >= 0
						? this.setActiveElement(this.previousTab)
						: this.setActiveElement(this.contents.length - 1);
					break;
				default:
					this.setActiveElement(0);
			}
		});
	},
};
